import React, { useEffect, useState } from "react";
import { Row, Col, Button, Card, Flex, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import config from "config";

import useRoleCheck from "utilities/hooks/roleCheck";
import ApplicationList from "./components/ApplicationList";
import ApplicationDetails from "./components/ApplicationDetails";
import NewApplication from "./components/NewApplication";

const Applications = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useRoleCheck();

  const [selectedApplication, setSelectedApplication] = useState(() => {
    const match = location.pathname.match(/^\/applications\/(\w+)/);
    return match ? match[1] : undefined;
  });
  const [newAppVisible, setNewAppVisible] = useState(false);

  useEffect(() => {
    const match = location.pathname.match(/^\/applications\/(\w+)/);
    if (match) {
      setSelectedApplication(match[1]);
    } else {
      setSelectedApplication(null);
    }
  }, [location.pathname]);

  const canApply = hasPermission(["Audiology"]) || config.applicationsEnabled;

  return (
    <div style={{ padding: 16, height: "100%" }}>
      <Row
        justify="center"
        align="middle"
        // style={{ height: "calc(100% - 56px)" }}
        style={{ height: "100%" }}
      >
        <Col span={6} style={{ height: "100%" }}>
          <Flex vertical style={{ height: "100%" }} gap="middle">
            <Tooltip
              title={
                canApply
                  ? "Create a new application"
                  : "Nominations are currently disabled"
              }
            >
              <Button
                disabled={!canApply}
                type="primary"
                onClick={() => {
                  setNewAppVisible(true);
                  setSelectedApplication(null);
                  navigate("/applications");
                }}
                icon={<PlusOutlined />}
              >
                New Nomination
              </Button>
            </Tooltip>
            <ApplicationList
              selectedApplication={selectedApplication}
              onSelect={(id) => {
                setSelectedApplication(id);
                setNewAppVisible(false);
              }}
            />
          </Flex>
        </Col>
        <Col span={18} style={{ height: "100%", paddingLeft: 16 }}>
          {selectedApplication ? (
            <ApplicationDetails id={selectedApplication} />
          ) : (
            <Card
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>Select an application to see details</div>
            </Card>
          )}
        </Col>
      </Row>
      <NewApplication visible={newAppVisible} setVisible={setNewAppVisible} />
    </div>
  );
};

export default Applications;
